module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/calendar/Event.ejs -->\n<div class="tooltip-event">\n    <div class="tooltip-header">\n        '+
((__t=( leaveRequest.getEmployee().get('fullName') ))==null?'':_.escape(__t))+
'\n    </div>\n    <div class="tooltip-description">\n        <div>'+
((__t=( leaveType.get('name') ))==null?'':_.escape(__t))+
'</div>\n        <div>\n            ';
 var approvedBy = leaveRequest.get('employeeApprovedByName') 
__p+='\n            ';
 var approvedByL2 = leaveRequest.get('employeeApprovedByNameL2') 
__p+='\n            ';
 var approvedByL3 = leaveRequest.get('employeeApprovedByNameL3') 
__p+='\n            ';
 var layer1Label = approvedByL2 ? 'Approved By (Layer 1):' : 'Approved By:' 
__p+='\n            ';
 var layer2Label = app.company.get('contactName') !== approvedByL2 ? 'Approved By (Layer 2):' : 'Approved By:' 
__p+='\n            ';
 var layer3Label = app.company.get('contactName') !== approvedByL3 ? 'Approved By (Layer 3):' : 'Approved By:' 
__p+='\n\n            ';
 if (leaveRequest.isAwaiting()) { 
__p+='\n                Awaiting Approval\n            ';
 } else if (leaveRequest.isApproved()) { 
__p+='\n                '+
((__t=( layer1Label ))==null?'':_.escape(__t))+
'\n                '+
((__t=( approvedBy || '-' ))==null?'':_.escape(__t))+
'\n            ';
 } else if (leaveRequest.isRejected()) { 
__p+='\n                Rejected By:\n                '+
((__t=( leaveRequest.get('rejectedByName') || '-' ))==null?'':_.escape(__t))+
'\n            ';
 } else if (leaveRequest.isCancelled()) { 
__p+='\n                Cancelled By:\n                '+
((__t=( leaveRequest.get('canceledByName') || '-' ))==null?'':_.escape(__t))+
'\n            ';
 } 
__p+='\n        </div>\n        ';
 if (leaveRequest.isApproved()) { 
__p+='\n            ';
 if (approvedByL2) { 
__p+='\n                <div>\n                    '+
((__t=( layer2Label ))==null?'':_.escape(__t))+
'\n                    '+
((__t=( approvedByL2 ))==null?'':_.escape(__t))+
'\n                </div>\n            ';
 } 
__p+='\n            ';
 if (approvedByL3) { 
__p+='\n                <div>\n                    '+
((__t=( layer3Label ))==null?'':_.escape(__t))+
'\n                    '+
((__t=( approvedByL3 ))==null?'':_.escape(__t))+
'\n                </div>\n            ';
 } 
__p+='\n        ';
 } else if (leaveRequest.hasApprovals() && !leaveRequest.isApproved()) { 
__p+='\n            <div>\n                Approved By (Layer 1):\n                '+
((__t=( approvedBy || '-' ))==null?'':_.escape(__t))+
'\n            </div>\n            ';
 if (approvedByL2) { 
__p+='\n                <div>\n                    Approved By (Layer 2):\n                    '+
((__t=( approvedByL2 ))==null?'':_.escape(__t))+
'\n                </div>\n            ';
 } 
__p+='\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/calendar/Event.ejs
// module id = 895
// module chunks = 1